<div class="flex h-screen">
  <!-- sideBar -->
  <div class="w-[19%] border border-[#E6E6E6] overflow-y-auto hide-scrollbar pb-[40px]">
    <div class="flex items-center">
      <h1 class="text-[#BE2F27] font-semibold text-[28px] leading-[100%] tracking-[-0.08em] py-[19px] ml-[24px]">
        bucca
      </h1>
      <p
        class="text-[#121212] font-medium text-[12px] ml-[18px] py-[3px] px-[6px] bg-[#F3F3F3] !tracking-[0%] rounded-[6px]">
        Super Admin
      </p>
    </div>
    <hr class="border-[#E6E6E6]" />
    <div class="pt-[24px]">
      <div class="ml-[24px]">
        <p class="flex py-[12.5px] px-[16px] text-[#121212] text-[14px] font-normal">General</p>

        <div>
          <div
            class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
            routerLink="/dashboard" routerLinkActive="sidebar-active">
            <img src="icons/dashboard.svg" />
            <a class="hover:text-white">Dashboard</a>
          </div>

          <div
            class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
            routerLink="/organisation" routerLinkActive="sidebar-active">
            <img src="icons/companies.svg" />
            <a class="hover:text-white">Organisations</a>
          </div>

          <div
            class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
            routerLink="/vendors" routerLinkActive="sidebar-active">
            <img src="icons/dashboard.svg" />
            <a class="hover:text-white">Vendors</a>
          </div>

          <div
            class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
            routerLink="/users" routerLinkActive="sidebar-active">
            <img src="icons/user.svg" />
            <a class="hover:text-white">Users</a>
          </div>

          <div
            class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
            routerLink="/admins-and-roles" routerLinkActive="sidebar-active">
            <img src="icons/admin-and-roles.svg" />
            <a class="hover:text-white">Admin & Roles</a>
          </div>

          <div
            class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
            routerLink="/billing-and-revenue" routerLinkActive="sidebar-active">
            <img src="icons/billing.svg" />
            <a class="hover:text-white">Billing & Revenue</a>
          </div>

          <div
            class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
            routerLink="/vendor-payouts" routerLinkActive="sidebar-active">
            <img src="icons/vendor-payout.svg" />
            <a class="hover:text-white">Vendor Payouts</a>
          </div>

          <div
            class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
            routerLink="/transactions" routerLinkActive="sidebar-active">
            <img src="icons/transactions.svg" class="hover:image-white" />
            <a class="hover:text-white">Transactions</a>
          </div>

          <div
            class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
            routerLink="/reports-and-export" routerLinkActive="sidebar-active">
            <img src="icons/reports.svg" />
            <a class="hover:text-white">Reports & Export</a>
          </div>
        </div>
      </div>

      <!-- safty -->

      <div class="mt-[12%] mx-[24px] rounded-[8px] p-[20px] bg-gradient-to-b from-[#FFF3F1] to-[#FFFFFF] w-[82%]">
        <div>
          <img src="icons/precaution.svg" />

          <h2 class="text-[#900B09] font-normal text-[11px] leading-[160%] tracking-[24%] mt-[16px]">
            SAFETY PRECAUTION
          </h2>
          <h3 class="font-semibold text-[14px] leading-[140%] tracking-[-2%] text-[#121212]">
            Safe Guard your account
          </h3>
          <p class="font-normal text-[#121212] text-[11px] leading-[160%] w-[88%]">
            Always make sure you logout and lock your pc
          </p>
        </div>
      </div>
      <!-- saftyend -->

      <div class="mx-[24px] mb-[40px]">
        <div
          class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
          routerLinkActive="sidebar-active">
          <img src="icons/settings.svg" class="hover:image-white" />
          <a href="" class="hover:text-white">Settings</a>
        </div>

        <div
          class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
          routerLinkActive="sidebar-active">
          <img src="icons/support.svg" class="hover:image-white" />
          <a href="" class="hover:text-white">Support</a>
        </div>

        <div (click)="logout()"
          class="flex py-[12.5px] my-[5px] px-[16px] gap-[12px] text-[#6A6A6A] hover:text-white hover:bg-black mr-[20px] active:text-white rounded-[8px] cursor-pointer"
          routerLinkActive="sidebar-active">
          <img src="icons/logout.svg" class="hover:image-white" />
          <a class="hover:text-white">Logout</a>
        </div>
      </div>
    </div>

    <!-- Logout Confirmation Modal -->
    <div *ngIf="isLogoutModalVisible"
      class="fixed inset-0 bg-black/40 backdrop-blur-xs flex items-center justify-center z-[9999] p-4">
      <div
        class="bg-white max-w-[400px] w-full rounded-[16px] border border-[#E6E6E6] p-[24px] shadow-[0px_8px_32px_rgba(0,0,0,0.08)] relative">
        <!-- Close Button -->
        <button
          class="absolute top-4 right-4 w-[28px] h-[28px] rounded-full border border-[#E5E5E5] flex items-center justify-center text-[#1A1A1A] hover:bg-gray-50 transition-colors"
          (click)="isLogoutModalVisible = false">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L11 11M1 11L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </button>

        <!-- Header -->
        <div class="flex flex-col items-center text-center mt-2 mb-6">
          <div class="w-[48px] h-[48px] rounded-full bg-[#FEE4E2] text-[#D92D20] flex items-center justify-center mb-4">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
          </div>
          <h3 class="text-[18px] font-semibold text-[#121212]">Confirm Logout</h3>
          <p class="text-[14px] text-[#6A6A6A] mt-2">Are you sure you want to log out of your account?</p>
        </div>

        <!-- Actions -->
        <div class="flex items-center gap-[12px]">
          <button type="button"
            class="flex-1 py-[12px] rounded-[10px] border border-[#E5E5E5] text-[14px] font-medium text-[#1A1A1A] hover:bg-gray-50 transition-colors cursor-pointer text-center"
            (click)="isLogoutModalVisible = false">
            Cancel
          </button>
          <button type="button"
            class="flex-1 py-[12px] rounded-[10px] bg-[#BE2F27] text-white text-[14px] font-medium hover:bg-[#a12821] transition-colors cursor-pointer text-center"
            (click)="confirmLogout()">
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- end -->

  <div class="space-y-8 bg-[#FAFAFA] overflow-y-auto hide-scrollbar w-full border">
    <!-- nav -->

    <div class="py-[14px] px-[24px] flex justify-between bg-[#FFFFFF] border-b h-[68px]">
      <div class="flex items-center">
        <div class="relative w-[414px]">
          <nz-icon [nzType]="'search'" [nzTheme]="'outline'" [nzSpin]="false"
            class="absolute left-3 top-1/2 -translate-y-1/2 text-black text-lg pointer-events-none"></nz-icon>

          <input type="text" nz-input placeholder="Search or type a command"
            class="w-full h-[44px] pl-10 pr-4 rounded-[12px] border border-[#E6E6E6] bg-white text-[14px] text-black placeholder:text-[#98A2B3] focus:outline-none focus:border-black" />
        </div>
      </div>

      <div class="flex items-center gap-6">
        <!-- notifications -->
        <div class="relative cursor-pointer">
          <img src="icons/bells.svg" class="w-6 h-6" />
          <span
            class="absolute -top-2 -right-3 bg-[#FEE4E2] text-[#F04438] text-[10px] font-bold px-1.5 py-0.5 rounded-full border border-white">
            245
          </span>
        </div>

        <!-- profile -->
        <div class="flex items-center gap-3  w-full">
          <div
            class="w-10 h-10 flex items-center justify-center bg-[#E6E8EA] rounded-lg text-[#171A1C] font-semibold text-sm">
            {{ userInitials }}
          </div>
          <div class="flex flex-col">
            <h2 class="text-[#121212] font-semibold text-sm leading-tight group">
              {{ userName }}
              <nz-icon nzType="down" class="text-[10px] ml-1 text-gray-400" />
            </h2>
            <h3 class="text-[#F59E0B] font-medium text-[11px] leading-tight">
              {{ userRole }}
            </h3>
          </div>
        </div>

      </div>
    </div>

    <!-- nav-end -->

    <router-outlet></router-outlet>
  </div>
</div>